export const NAME = 'core-i18n';
